var m = require('mithril');
var prop = require('mithril/stream')
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var Model = require('../../libs/Model');
var Dashboard = Object.assign(require('../../../../../models/dashboards/dashboard'), Model);
var trees = require('../../components/trees');

var addElementModal = {};

var DashboardTree = {root: Dashboard, name: 'Dashboards', leafClass: 'Element', edgeClass: 'Contains', ancestorClass: 'ancestors', '@id': '/api/v1/dashboard/'};

addElementModal.element = prop({})
addElementModal.error = prop('')

addElementModal.selectElement = function (element) {
  if (arguments.length) {
    addElementModal.error('');
    addElementModal.element(element || {});
  }
  return addElementModal.element();
}

addElementModal.editDialogue = function (record) {
  addElementModal.element({});
  addElementModal.error('');

  var submit = function () {
    var selectedElement = addElementModal.element();
    if (!selectedElement || !selectedElement['@rid']) {
      addElementModal.error('Choose a dashboard sheet before saving.');
      m.redraw();
      return;
    }

    return loaders.requestWithLoader({
      loader: 'submit',
      url: Model.urlForRecord(record) + '/addElement',
      method: 'PUT',
      body : {
        element: selectedElement['@rid']
      }
    })
    .then(function (data) {
      modal.vm.close();
    })
  };

  modal.vm.title("Select Element");
  modal.vm.body = addElementModal;
  modal.vm.buttons([
    {
      label: "Submit",
      func: submit
    }
  ])

  modal.vm.open()
};

addElementModal.view = function () {
  return m('form.form-dark', {role:'form'}, [
    addElementModal.error() ? m('div.red.mb2', addElementModal.error()) : null,
    m(trees, {trees: [DashboardTree], selector: addElementModal.selectElement})
  ])
}
module.exports = addElementModal;
